<template>
  <div
    v-bind="$attrs"
    :class="`text-white base-icon-badge--custom bg-${getColorSuffix(color, false)} ${
      rounded ? 'rounded-circle' : ''
    }`"
    class="fw-bold d-flex align-items-center justify-content-center user-select-none overflow-hidden"
  >
    <BasePortalIcon :icon="icon" :width="width" :height="height" />
  </div>
</template>

<script lang="ts" setup>
import { getColorSuffix } from '@/helpers/status.helper'
import { LeadStatusColor } from '@/shared'
import { PropType } from 'vue'

defineProps({
  icon: {
    type: String,
    default: '',
  },
  color: {
    type: String as PropType<LeadStatusColor>,
    required: false,
    default: '',
  },
  rounded: {
    type: Boolean,
    default: true,
  },
  width: {
    type: String,
    required: false,
    default: '1.25em',
  },
  height: {
    type: String,
    required: false,
    default: '1.25em',
  },
})
</script>

<style lang="scss" scoped>
.base-icon-badge--custom {
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
  min-height: 2rem;
  &-md {
    width: 1.5rem;
    min-width: 1.5rem;
    height: 1.5rem;
    min-height: 1.5rem;
  }
  &-sm {
    width: 1.25rem;
    min-width: 1.25rem;
    height: 1.25rem;
    min-height: 1.25rem;
  }
}
</style>
